import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { MenuTriggerDirective } from './menu-trigger.directive';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuDividerComponent } from './menu-divider/menu-divider.component';

@NgModule({
  declarations: [
    MenuComponent,
    MenuTriggerDirective,
    MenuItemComponent,
    MenuDividerComponent,
  ],
  imports: [CommonModule],
  exports: [
    MenuComponent,
    MenuTriggerDirective,
    MenuItemComponent,
    MenuDividerComponent,
  ],
})
export class MenuModule {}
